import { render } from "./ForbrugTable.vue?vue&type=template&id=a38cde06&scoped=true"
import script from "./ForbrugTable.vue?vue&type=script&lang=js"
export * from "./ForbrugTable.vue?vue&type=script&lang=js"

import "./ForbrugTable.vue?vue&type=style&index=0&id=a38cde06&scoped=true&lang=css"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a38cde06"]])

export default __exports__